// Botão principal da marca (violeta #7869DF → #4433B4, brilho passando) do convite da Meta de Frentista:
// o "Ver agora grátis" do pop-up e o "Abrir o monitor ao vivo" da degustação ativa.
import React from 'react';
import { Button, ButtonProps, keyframes } from '@mui/material';

const VIOLET = '#7869DF';
const VIOLET_DARK = '#4433B4';
export const CTA_GRADIENT = `linear-gradient(135deg, ${VIOLET} 0%, ${VIOLET_DARK} 100%)`;

const shine = keyframes`
  0%, 55% { transform: translateX(-120%) skewX(-20deg); }
  100% { transform: translateX(260%) skewX(-20deg); }
`;

/** Desliga a animação para quem pede "reduzir movimento". */
export const noMotion = { '@media (prefers-reduced-motion: reduce)': { animation: 'none' } };

/** `grow`: ocupa o espaço que sobra na linha só no celular (barra fixa do pop-up); de `sm` em diante o botão mantém a largura natural. */
const GradientButton: React.FC<ButtonProps & { grow?: boolean }> = ({ grow, sx, ...props }) => (
  <Button
    variant="contained"
    {...props}
    sx={{
      position: 'relative', overflow: 'hidden', px: 3, py: 1.4, borderRadius: 3, fontSize: 15, fontWeight: 800,
      textTransform: 'none', letterSpacing: '0.01em', color: '#fff', background: CTA_GRADIENT,
      boxShadow: '0 10px 24px rgba(68,51,180,0.35)', flex: grow ? { xs: '1 1 auto', sm: 'none' } : undefined, minHeight: 48,
      transition: 'transform .2s ease, box-shadow .2s ease',
      '&:hover': { background: CTA_GRADIENT, transform: 'translateY(-2px)', boxShadow: '0 14px 30px rgba(68,51,180,0.42)' },
      '& .MuiButton-endIcon': { transition: 'transform .2s ease' },
      '&:hover .MuiButton-endIcon': { transform: 'translateX(4px)' },
      '&::after': {
        content: '""', position: 'absolute', top: 0, bottom: 0, left: 0, width: '35%',
        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.45), transparent)',
        animation: `${shine} 3.2s ease-in-out infinite`, ...noMotion,
      },
      ...sx,
    }}
  />
);

export default GradientButton;
